import { Button } from "@shopify/polaris";

import React, { useMemo, useRef } from "react";
import { OpenDromoContainer, UploadFileSpan } from "../../styles";
import DromoUploader from "dromo-uploader-react";

import { MigrationsTableAccess } from "../../stores/MigrationsTable";
import { MigrationFileUploadStoreAccess } from "../../stores/MigrationFileUpload";
import { BulkUpdatesTableAccess } from "../../stores/BulkUpdatesTable";
import { BulkUpdateFileUploadStoreAccess } from "../../stores/BulkUpdateFileUpload";

import { blockedStatuses, dromoLicenseKey } from "../../libs/utils/constants";

export const DromoContainer = ({ schemaId, uploadType }) => {
  const isMigration = uploadType === "migration";

  const migrationFiles = MigrationsTableAccess.useFiles();
  const migrationTableActions = MigrationsTableAccess.useActions();
  const migrationUploadActions = MigrationFileUploadStoreAccess.useActions();

  const bulkUpdateFiles = BulkUpdatesTableAccess.useFiles();
  const bulkUpdateTableActions = BulkUpdatesTableAccess.useActions();
  const bulkUpdateUploadActions = BulkUpdateFileUploadStoreAccess.useActions();

  const isUploadingOrCommitting = useMemo(() => {
    return isMigration
      ? migrationFiles.some(file => blockedStatuses.includes(file.status))
      : bulkUpdateFiles.some(file => blockedStatuses.includes(file.status));
  }, [migrationFiles, bulkUpdateFiles]);

  const dromoRef = useRef<DromoUploader | null>(null);

  const onResults = async (_data, metadata) => {
    if (isMigration) {
      await migrationUploadActions.uploadFile(metadata.id!);
      await migrationTableActions.fetchFiles();
    } else {
      await bulkUpdateUploadActions.uploadFile(metadata.id!, uploadType);
      await bulkUpdateTableActions.fetchFiles(uploadType);
    }
  };

  return (
    <div data-testid="manual-migration-upload-zone">
      <DromoUploader
        licenseKey={dromoLicenseKey}
        ref={dromoRef}
        onResults={onResults}
        developmentMode={false}
        schemaId={schemaId}
      />
      <OpenDromoContainer>
        <Button size="large" disabled={isUploadingOrCommitting} primary onClick={() => dromoRef.current?.open()}>
          Import Data
        </Button>
        <UploadFileSpan>
          {isUploadingOrCommitting
            ? "Please wait while we process your last upload."
            : "Upload your CSV file using our importer"}
        </UploadFileSpan>
      </OpenDromoContainer>
    </div>
  );
};
